var API_LOCALE_PLACEMENT;
(function (API_LOCALE_PLACEMENT) {
    API_LOCALE_PLACEMENT["HEADER"] = "header";
    API_LOCALE_PLACEMENT["PARAM"] = "param";
})(API_LOCALE_PLACEMENT || (API_LOCALE_PLACEMENT = {}));
export { API_LOCALE_PLACEMENT };
//# sourceMappingURL=api.js.map